import editor from "./editor";
import commonHelpers from "common/plugins/issues/compare_parameter_values";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
